import { render } from "./DbsUnlockingBottomButtons.vue?vue&type=template&id=7645ea96&scoped=true"
import script from "./DbsUnlockingBottomButtons.vue?vue&type=script&lang=js"
export * from "./DbsUnlockingBottomButtons.vue?vue&type=script&lang=js"

import "./DbsUnlockingBottomButtons.vue?vue&type=style&index=0&id=7645ea96&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7645ea96"

export default script